export default __webpack_public_path__ + "static/media/dinerKlein.2e44ae23.jpg";